/* eslint-disable @typescript-eslint/no-explicit-any */
import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';

export interface IMantenance {
    arquivo?: File;
    nome: string;
    descricao: string;
    uuid?: string;
    localTrabalho: string,
    frequencia: string,
    tempo: string,
    responsavel: string;
    id_barragem?: string;
    datas?: string;
}

const create = async (data: IMantenance): Promise<any | Error> => {
    try {
        await AuthService.verify();
    
        const token = await AuthService.getAccessToken();
    
        // const response = await ApiBack.post(`/planejamento?uuid=${uuid}`, data, {
        const response = await ApiBack.post('/planejamento', data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `${token}` 
            }
        });
    
        if (response.data) {
            return response.data;
        }
    
        return new Error('Erro ao criar planejamento');
    } catch (error: any) {
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao criar planejamento');
        }
    }
};

const get = async (uuid:string): Promise<IMantenance | Error> => {
    
    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get(`./planejamento?uuid=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if (response.data) {
            return response.data;
        }

        return new Error('Erro ao listar registros.');
    } catch (error) {
        console.error(error);
        return new Error((error as { message: string }).message || 'Erro na requisição de listagem.');
    }
};

const list = async (uuid:string): Promise<IMantenance[] | Error> => {
    
    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get(`./planejamentos?uuid=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if (response.data) {
            return response.data;
        }

        return new Error('Erro ao listar registros.');
    } catch (error) {
        console.error(error);
        return new Error((error as { message: string }).message || 'Erro na requisição de listagem.');
    }
};

const upgrade = async(uuid: string, data: IMantenance): Promise<any | Error> => {

    await AuthService.verify();

    try{
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.put(`./planejamento?uuid=${uuid}`, data, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data){
            return response.data;
        }
        
        return new Error('Falha ao atualizar registro');
    } catch (error) {
        return new Error((error as { menssage: string}).menssage || 'Error ao atualizar registro');
    }
};

const delet = async(uuid: string): Promise<any | Error> => {

    await AuthService.verify();

    try{
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.delete('./planejamento', {
            headers: {
                Authorization: `${token}`
            },
            params: {
                'uuid': uuid
            }
        });

        if(response.data){
            return response.data; 
        }

        return new Error('Falha ao deletar registro');
    } catch (error) {
        Error((error as { message: string}).message || 'Erro ao deletar registro');
    }
};

export const MaintenancesServices = {
    create,
    get,
    list,
    upgrade,
    delet
};